import React from "react";
import RootStore from "./store/mobx";

export const StoreContext = React.createContext(null);

export const useStore = (): RootStore => {
    return React.useContext(StoreContext)
};

